import { useSyncExternalStore } from 'react';

let forcedOffline = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener('online', listener);
  window.addEventListener('offline', listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('online', listener);
    window.removeEventListener('offline', listener);
  };
}

/**
 * Whether the page reaches the network, as the browser says (always online on a server). On a
 * desktop the conversation's server may run on this machine and still answer: messages wait all
 * the same, since its agent needs the network (its model) to answer them.
 */
export function isOnline(): boolean {
  if (forcedOffline) return false;
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

/** The preview (and tests) show the page offline (design D53). */
export function forceOffline(offline: boolean): void {
  forcedOffline = offline;
  for (const listener of listeners) listener();
}

/** Online now; follows the browser's `online` and `offline` events. */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, isOnline, () => true);
}
